import Default from '@app/constants';
import { FilterTransactionLogs } from '@app/typings/services/winnonie/logs';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const filterTransactionsBrand: string = 'winnonie/brand/transactions.filters';
const filterTransactionsProject: string = 'winnonie/project/transactions.filters';

const defaultBrandLevel = Default.filter.winnonie.transactionsBrandLevel;
const defaultProjectLevel = Default.filter.winnonie.transactionsProjectLevel;

export const setFilterTransactionsBrandWinnonie = (value: FilterTransactionLogs) => {
  set(filterTransactionsBrand, value);
};

export const getFilterTransactionsBrandWinnonie = (): FilterTransactionLogs => {
  return (
    get(filterTransactionsBrand) || {
      filters: defaultBrandLevel,
      pages: Default.pages,
    }
  );
};

export const clearFilterTransactionsBrandWinnonie = () => {
  return set(filterTransactionsBrand, {
    filters: defaultBrandLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterTransactionsBrandWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};

export const setFilterTransactionsProjectWinnonie = (value: FilterTransactionLogs) => {
  set(filterTransactionsProject, value);
};

export const getFilterTransactionsProjectWinnonie = (): FilterTransactionLogs => {
  return (
    get(filterTransactionsProject) || {
      filters: defaultProjectLevel,
      pages: Default.pages,
    }
  );
};

export const clearFilterTransactionsProjectWinnonie = () => {
  return set(filterTransactionsProject, {
    filters: defaultProjectLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterTransactionsProjectWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
